module.exports = __webpack_public_path__ + "static/media/Home-background.ed6507af.png";